module.exports = __webpack_public_path__ + "static/Symphonia-end-c00f2bfc639eb0f5d93bbde4936004b9.webp";